import React from 'react';

interface ProductInfoProps {
  title: string;
  description: string;
  rating?: number;
  reviewCount?: number;
}

const ProductInfo: React.FC<ProductInfoProps> = ({ 
  title, 
  description, 
  rating = 5, 
  reviewCount = 0 
}) => {
  return (
    <div className="product-info mb-4">
      <h3 className="fs-18 fw-medium lh-base lh-sm mb-3">
        {title}
      </h3>
      
      <p className="text-secondary mb-3">
        {description}
      </p>
    </div>
  );
};

export default ProductInfo;
